export const DEFAULT_PARAMS = {
  ss: '1',
  pic: '1',
  ds: '0',
  so: '50',
  tp: '1',
};
